import { Flex } from 'antd';
import CardDetailButton from '../cardDetailButton/cardDetailButton';
import InteractiveCard from '../common/interactiveCard';
import { Divider } from '../Ant';
import { DollarCircle, ProfileUser } from '../icons';
import CardData from '../dashboard/cardData';
import { useTranslation } from 'react-i18next';
import { IRole } from '../../interface/matterParties';
import { getTranslationFromTranslatableEntity } from '../../constants/matter';
import { useLanguage } from '../../context/LanguageContext';
import { PAYER_ROLE_ID } from '../../constants/conflictSearch';
import { isEqual } from 'lodash';
import { ICustomerType } from '../../constants/customer';
import { BorderColor, TagColor } from '../../interface/common';

interface IParty {
  id: string;
  customerName: string;
  roles: IRole[];
  customerType: ICustomerType;
  sharePercentage?: string;
  onPress: () => void;
}
const PartiesCard = ({
  id,
  customerName,
  roles,
  customerType,
  sharePercentage,
  onPress,
}: IParty) => {
  const { t } = useTranslation();
  const { getAppLanguageCode } = useLanguage();

  return (
    <InteractiveCard
      key={id}
      data-testid="party-card"
      className={`pointer w-full customer-card ${customerType === ICustomerType.COMPANY ? BorderColor.GREEN : BorderColor.YELLOW}`}
      onActivate={onPress}
    >
      <Flex justify="space-between" align="center" className="pb-10">
        <Flex gap={8} align="center">
          <Flex
            data-testid="customer-type-chip"
            justify="center"
            align="center"
            className={`status-chip ${customerType === ICustomerType.COMPANY ? TagColor.GREEN : TagColor.YELLOW}`}
          >
            {customerType === ICustomerType.COMPANY
              ? t('customer:customerType.company')
              : t('customer:customerType.privatePerson')}
          </Flex>
        </Flex>

        <Flex gap={10}>
          <CardDetailButton onOpen={onPress} testId="go-detail-button" />
        </Flex>
      </Flex>
      <Divider className="mb-10" />
      <Flex vertical gap={10}>
        <CardData
          type="matter"
          icon={<ProfileUser />}
          title={t('matter:party')}
          content={customerName}
          subcontent={(roles ?? [])
            ?.map((role) =>
              getTranslationFromTranslatableEntity(
                role?.matterPartyRole.translations,
                getAppLanguageCode(),
              ),
            )
            .join(', ')}
          contentclass="lineclamp-1"
        />
        {sharePercentage &&
          (roles ?? [])?.some((role) => isEqual(role?.matterPartyRole?.id, PAYER_ROLE_ID)) && (
            <CardData
              type="payers-percentage"
              icon={<DollarCircle />}
              title={t('matter:payersPercentage')}
              content={`${sharePercentage}%`}
            />
          )}
      </Flex>
    </InteractiveCard>
  );
};

export default PartiesCard;
